webpackJsonp([1],{

/***/ 117:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["getShareConfig"] = getShareConfig;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createReducer__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_request__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_es_toast_style_css_js__ = __webpack_require__(88);
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};




var dict = {
  Baohe: 0,
  WeChat: 1,
  Moments: 2,
  DingTalk: 3,
  Browser: 4,
  CopyLink: 5
};
var namespace = "article";
var initialState = {
  shareConfig: null
};
var reducer = {
  onGetShareConfigSuc: function onGetShareConfigSuc(state, action) {
    if (action.error || action.result.error) {
      return state;
    }

    var _a = action.result,
        enable = _a.enable,
        channels = _a.channels;
    var menus = [];

    if (enable) {
      menus = channels.map(function (channel) {
        return dict[channel];
      }).filter(function (_) {
        return typeof _ !== 'undefined';
      });
    }

    if (global.zt && global.zt.setShareMenu) {
      global.zt.setShareMenu({
        menus: menus
      });
    }

    return __assign(__assign({}, state), {
      shareConfig: action.result
    });
  },
  onGetShareConfigErr: function onGetShareConfigErr(state, action) {
    // Toast.fail("获取附件失败", 2);
    return {
      state: state
    };
  }
};
/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_0__utils_createReducer__["a" /* createReducer */])(initialState, reducer, namespace));
function getShareConfig(action) {
  return {
    types: ["article/onGetShareConfig", "article/onGetShareConfigSuc", "article/onGetShareConfigErr"],
    promise: Object(__WEBPACK_IMPORTED_MODULE_1__utils_request__["c" /* request */])("/get_article_share", {
      method: "GET",
      body: {
        uuid: action.articleId
      }
    })
  };
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(13)))

/***/ }),

/***/ 184:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var context = __webpack_require__(320);

var keys = context.keys().filter(function (item) {
  return item !== './index.ts';
});
var reducersKeys = keys.reduce(function (memo, key) {
  //eslint-disable-next-line
  memo[key.match(/([^\/]+)\.ts$/)[1]] = context(key)["default"];
  return memo;
}, {});
/* harmony default export */ __webpack_exports__["default"] = (reducersKeys);

/***/ }),

/***/ 186:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["makePraise"] = makePraise;
/* harmony export (immutable) */ __webpack_exports__["makeComment"] = makeComment;
/* harmony export (immutable) */ __webpack_exports__["deleteComment"] = deleteComment;
/* harmony export (immutable) */ __webpack_exports__["stickComment"] = stickComment;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createReducer__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_request__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_es_toast__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_es_toast_style_css_js__ = __webpack_require__(88);
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};





var namespace = "comment";
var initialState = {
  commentList: [],
  readInfo: {}
};
var reducer = {
  getCommentList: function getCommentList(state, action) {
    if (action.error || action.result.error) {
      {
        var params = new URLSearchParams(window.location.search);
        var notAuthorized = params.get('authorized') === 'false';
        console.log('getCommentList notAuthorized: ', notAuthorized);
        console.log('getCommentList navigator.userAgent: ', navigator.userAgent);

        if (!notAuthorized && action.result && action.result.error === "need_login_first") {
          if (/ztobox|ztbox|baohe/.test(navigator.userAgent.toLowerCase())) {
            // 为防止不明原因导致可能存在的无限跳转, 需要额外记录上次刷新时间, 如果在5秒之内, 就不再刷新
            var lastLogin = localStorage.getItem("lastLoginByComment");
            console.log("上次登录时间 -> ", lastLogin);

            if (lastLogin !== null) {
              var lastTime = parseInt(lastLogin);
              var nowDate_1 = Date.now();

              if (nowDate_1 - lastTime < 1000 * 5) {
                // 不跳转
                return __assign(__assign({}, state), {
                  commentList: []
                });
              }
            }

            var nowDate = Date.now();
            localStorage.setItem("lastLoginByComment", "" + nowDate);
            Object(__WEBPACK_IMPORTED_MODULE_1__utils_request__["b" /* jumpToOAuth2 */])();
          }
        }
      }
      return __assign(__assign({}, state), {
        commentList: []
      });
    }

    return __assign(__assign({}, state), {
      commentList: formatData(action.result.comments),
      readInfo: action.result.readInfo
    });
  },
  onCommentErr: function onCommentErr(state) {
    __WEBPACK_IMPORTED_MODULE_2_antd_mobile_es_toast__["a" /* default */].fail("评论失败！", 2);
    return state;
  },
  onDeleteErr: function onDeleteErr(state) {
    __WEBPACK_IMPORTED_MODULE_2_antd_mobile_es_toast__["a" /* default */].fail("删除失败！", 2);
    return state;
  },
  onPraise: function onPraise(state, action) {
    if (action.action.commentId === 0) {
      return state;
    }

    var commentList = state.commentList.slice();
    commentList.find(function (item) {
      if (item.id === action.action.commentId) {
        item.praised = true;
        item.praise_num = item.praise_num + 1;
        return true;
      }

      return false;
    });
    return __assign(__assign({}, state), {
      commentList: commentList
    });
  }
};
/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_0__utils_createReducer__["a" /* createReducer */])(initialState, reducer, namespace));
function makePraise(action) {
  return {
    type: "comment/onPraise",
    promise: Object(__WEBPACK_IMPORTED_MODULE_1__utils_request__["c" /* request */])("/praise?commentId=" + action.commentId, {
      method: "post"
    }),
    action: action
  };
}
function makeComment(action) {
  return {
    types: ["comment/onCommentLoad", "comment/onCommentSuc", "comment/onCommentErr"],
    promise: Object(__WEBPACK_IMPORTED_MODULE_1__utils_request__["c" /* request */])("/put_comment", {
      method: "post",
      body: action
    }),
    action: action
  };
}
function deleteComment(action) {
  return {
    types: ["comment/onDeleteLoad", "comment/onCommentSuc", "comment/onDeleteErr"],
    promise: Object(__WEBPACK_IMPORTED_MODULE_1__utils_request__["c" /* request */])("/del_comment", {
      method: "post",
      body: action
    })
  };
}
function stickComment(action) {
  return {
    types: ["comment/onStickLoad", "comment/onCommentSuc", "comment/onStickErr"],
    promise: Object(__WEBPACK_IMPORTED_MODULE_1__utils_request__["c" /* request */])("/stick_comment", {
      method: "post",
      body: action
    })
  };
}

function formatData(data) {
  var newData = [];

  var _loop_1 = function _loop_1(item) {
    if (!item.reply_id) {
      newData.push(item);
    } else {
      newData.find(function (i) {
        if (i.id === item.reply_id) {
          i.reply = i.reply ? __spreadArrays(i.reply, [item]) : [item];
          return true;
        }

        return false;
      });
    }
  };

  for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
    var item = data_1[_i];

    _loop_1(item);
  }

  return newData;
}

/***/ }),

/***/ 203:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getFileList"] = getFileList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createReducer__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_request__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_es_toast_style_css_js__ = __webpack_require__(88);
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};




var namespace = "file";
var initialState = {
  files: [],
  hasFile: false
};
var reducer = {
  onGetFileListSuccess: function onGetFileListSuccess(state, action) {
    if (action.error || action.result.error) {
      return __assign(__assign({}, state), {
        files: [],
        hasFile: false
      });
    }

    return __assign(__assign({}, state), {
      files: action.result,
      hasFile: true
    });
  },
  onGetFileListFailed: function onGetFileListFailed(state, action) {
    // Toast.fail("获取附件失败", 2);
    return {
      state: state,
      hasFile: false
    };
  }
};
/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_0__utils_createReducer__["a" /* createReducer */])(initialState, reducer, namespace));
function getFileList(action) {
  return {
    types: ["file/onGetFileList", "file/onGetFileListSuccess", "file/onGetFileListFailed"],
    promise: Object(__WEBPACK_IMPORTED_MODULE_1__utils_request__["c" /* request */])("/get_attach_file", {
      method: "GET",
      body: {
        id: action.articleId
      }
    }),
    action: action
  };
}

/***/ }),

/***/ 204:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(111);
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

 // Use require.context to require sagas automatically
// Ref: https://webpack.github.io/docs/context.html

var context = __webpack_require__(379);

var keys = context.keys().filter(function (item) {
  return item !== './index.ts';
});

function root() {
  var _i, keys_1, key, _a, _b, item;

  return __generator(this, function (_c) {
    switch (_c.label) {
      case 0:
        _i = 0, keys_1 = keys;
        _c.label = 1;

      case 1:
        if (!(_i < keys_1.length)) return [3
        /*break*/
        , 6];
        key = keys_1[_i];
        _a = 0, _b = Object.values(context(key));
        _c.label = 2;

      case 2:
        if (!(_a < _b.length)) return [3
        /*break*/
        , 5];
        item = _b[_a];
        return [4
        /*yield*/
        , Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* fork */])(item)];

      case 3:
        _c.sent();

        _c.label = 4;

      case 4:
        _a++;
        return [3
        /*break*/
        , 2];

      case 5:
        _i++;
        return [3
        /*break*/
        , 1];

      case 6:
        return [2
        /*return*/
        ];
    }
  });
}

var CANCEL_SAGAS_HMR = 'CANCEL_SAGAS_HMR';

function createAbortableSaga(saga) {
  if (false) {
    return function main() {
      var sagaTask;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , fork(saga)];

          case 1:
            sagaTask = _a.sent();
            return [4
            /*yield*/
            , take(CANCEL_SAGAS_HMR)];

          case 2:
            _a.sent();

            return [4
            /*yield*/
            , cancel(sagaTask)];

          case 3:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    };
  } else {
    return saga;
  }
}

var SagaManager = {
  startSagas: function startSagas(sagaMiddleware) {
    sagaMiddleware.run(createAbortableSaga(root));
  },
  cancelSagas: function cancelSagas(store) {
    store.dispatch({
      type: CANCEL_SAGAS_HMR
    });
  }
};
/* harmony default export */ __webpack_exports__["default"] = (SagaManager);

/***/ }),

/***/ 241:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACmUlEQVRYR8VWPWgTYRh+nktaWhy0UFEcnCpUwcFFUNCCUCy1uUvFOvgDCtKLoYsIQgcnpVPBQaRJ/BksONghl4s/VFx0KBREBaHUQQcHRfyjoimNyffKtbak5ufukiu9Ldzzx/O++e4j1vnhOvujYoDe+MOtYZU/SbBbIC0QzgOcBTH9p6np0ePrvT8rBdfNTDcgR0HZSVAAfAQwI8JJO2m8qMQpCxCJpc9owmsgNlUiCLAAyE0UtKv2LeOzg9HPZbYgLCkCerVGBXgLxct2ypgoxawEGLhwvzWfa74HIuplLCL4qlEGikoKpJYm0e6FB4E1n2s99WT88G8HvxLAMK07IM56EvkHEsAZxS8C2/zwADxt/pbvmZg4XlwMYJhWBITtU6QhuEDidqJ/jIBQNzMzJDobUvRJFsh7OxHtYF8svTcETvvkBwIXYRd1Mz1MciQQRZ8iAl6hblpjJGI+uUHBkzRi1l0Ap4NS9KkzTj2WHiV40ScxGLhglIZpHQOx6nQKRt1dRYmc4NIJ2PQJ5EZ3SnAIAQo5taF98SDSzfQIyeHg5N2VRHDDTkaHFgMcOf+gLaQKr0lsd6c2jhDBh4VCy57J2z3fV74FejzTAaWmCG5u3KK6gkC+aAr7rFT/u1UfI+dHZDDbSa3wfK1COOaiwgezqcjscsTy+8AahahkXtbAcqqgm6hmXjVAkOMQ4Ieo0P7S2ks3pOaltNEmHHMqdGVS0TfV1tL1VrwUojhFoM3Pv8OLec0RlJoZg9Zu0fDMawiv5p4DOEDPIUTmIDxQq3bPO/B/5a4hROaUhA9lU5GXXsflugOeQ9Rh7msENXeiTvO6AzjEPjO7I8TiEIBdAl6yE8Yrr7XXvQP1GLhxfO+Am6Df938B8BcS5hhTk+IAAAAASUVORK5CYII="

/***/ }),

/***/ 242:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAD10lEQVRYR8WWXWgcZRiFz5mN202K9a8oLQR7Uw31D42gVJrWXki17MykmFAshWiT3bVK1RtR/CGiF9YLA0qT3a2tWlMIbc3uzNqWQGtQq3gTb4pUESz+1YhVUlFDk+wcmbUJS5PNTHcDndvvPe95vvO9M/MRl/nhZfZHBQDRTLrNoPcgwSYAyy+AfgvikNNnH5sL3O7IXe3FjA2UVgtYCaoe4jiB45ORK/qP9G4cvVg3C8BMOG0w9CqBmyulI+EwitzmvmP95teYnc4NiOglEJ0EFs2pk84B3OFk7H3l6zMAD2wdWlzfMN4PwhZwBmCWhvY6vfZPpbXY+B2eoWYCHSTvknBW8lpFLjLAAVLXSjwqat8ZrzE3km2eincWVtDQKlJrBDxFIgYhH22YeORgT/u4D1ICWNc9XLdkdGyI4HpJg7+ocfNI9u7JuRMQ48n8kwTfADEGYTEAA2LczVrDlVKzU7kVnvg+iRYA7zlp+9EZACuZ3w5il6QT7jJ7LbrpBQ2nlcjfA+pzkBEAm5y0nQvSoFuGOeoMEGgTabl9lktAtFL50xCWT9ZFVx7ZtfGHwEYXCuKpXDthGG7aGgirWdcxHLsqNvYzhD+cjN1EM+HcT0MfC+pz063bwzaqpc5K5l8G8Qo83Ovv/jUAL4Bocfrsz2ppHFZbOj4DXwJ40QfYDaBz4nz0+qPvPvR72Ca11MUThaWGUfS9MjRT+X4CW6LGxJUHe9v/rqVxWG3bMwfqJ8aj/wrYTzPp9JB62isatxZ2m1+HbVJLnf9KCjwNoIdmytlCqN+TdhQyrW/X0jis1kw5XYSyENronweN4q8UTjkZ+/awTWqps1K5kxAaow2Ty0pfQjOZ7yORgvCck7F31tI8SGumcs8S3OkBrxfS9vMlgNYnBq/zihwBeKPAbW7a2hvUqJp1M+U8RmiPhB/PT8XuHNqz4c+Zn1Fr1+BNxQhPQFwKcqubtvZXY1JJ488apA9AnfVUd99Hmfh3M/+CaVE8UWiiMfXpQkOUm8uraylk499Me866Dyw0xHzmsxJY6CSCzCsC+Au1JmEl8w8LOODfGeRFVpfHXj4n815KyyEItDsZ+1CYwfTNAQ2I/Ise1jpZ+2QlXeCt+H+I4heUlgDcHARxKebzHkE5sZXI3yYDnwRBmI87Jj1vMMzOK74FlaIKgvDNIX1I6R+Ia+aLPfQMXAxTCaLc3FPd+kI2/lWYWQl9BPMdhwxOTO/8Us2rAvBFM0kA15TgpHPVmFcNUPpOdLm3GEbxTYHfFyPeW4d7N50KG3vVM1CNQZAm8DsQ1KDW9f8Aa9fl31I2f2YAAAAASUVORK5CYII="

/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(244);
module.exports = __webpack_require__(249);


/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(245).enable();
  window.Promise = __webpack_require__(247);
}

// fetch() polyfill for making API calls.
__webpack_require__(248);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(109);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),

/***/ 249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_css__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lazyload__ = __webpack_require__(613);




 // 设置宝盒分享的标题和描述

if (/ztobox|ztbox|baohe/.test(navigator.userAgent.toLowerCase())) {
  var location = global.location;
  var url = location.protocol + "//" + location.hostname + (location.port ? ":" + location.port : "") + location.pathname;

  if (global.zt && global.zt.setTitle && global.PageTitle) {
    global.zt.setTitle({
      title: global.PageTitle,
      bgcolor: '#ffffff'
    });
  }

  if (global.zt && global.zt.updateShareContent) {
    var shareConfig = {
      title: global.PageTitle || '',
      desc: global.Title || '',
      thumbImageUrl: global.AppIcon || '',
      webpageUrl: url,
      timeline: global.Title || ''
    };
    global.zt.updateShareContent(shareConfig);
  }
}

__WEBPACK_IMPORTED_MODULE_1_react_dom__["render"](__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */], null), document.getElementById('root'));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(13)))

/***/ }),

/***/ 254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_logger__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_redux_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_promiseMiddleware__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reducers_index__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__sagas_index__ = __webpack_require__(204);
var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};











/* global location */

/* eslint no-restricted-globals: ["off", "location"] */

var sagaMiddleware = Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga__["a" /* default */])();
var middleware = [__WEBPACK_IMPORTED_MODULE_7__utils_promiseMiddleware__["a" /* default */], sagaMiddleware];

if (false) {
  middleware.push(logger);
} else {
  __webpack_require__(381);
}

var enhancer = Object(__WEBPACK_IMPORTED_MODULE_1_redux__["d" /* compose */])(__WEBPACK_IMPORTED_MODULE_1_redux__["a" /* applyMiddleware */].apply(void 0, middleware), window.devToolsExtension ? window.devToolsExtension() : function (f) {
  return f;
});
var initialState = {};
var store = Object(__WEBPACK_IMPORTED_MODULE_1_redux__["e" /* createStore */])(Object(__WEBPACK_IMPORTED_MODULE_1_redux__["c" /* combineReducers */])(__assign(__assign({}, __WEBPACK_IMPORTED_MODULE_8__reducers_index__["default"]), {
  routing: __WEBPACK_IMPORTED_MODULE_4_react_router_redux__["routerReducer"]
})), initialState, enhancer); // run sagas

__WEBPACK_IMPORTED_MODULE_9__sagas_index__["default"].startSagas(sagaMiddleware);

if (false) {
  module.hot.accept('./reducers', function () {
    var nextRootReducer = require('./reducers/index');

    var combinedReducers = combineReducers(__assign(__assign({}, nextRootReducer), {
      routing: routing
    }));
    store.replaceReducer(combinedReducers);
  });
  module.hot.accept('./sagas', function () {
    sagaManager.cancelSagas(store);

    require('./sagas/index')["default"].startSagas(sagaMiddleware);
  });
}

var Home = global.noAuth ? __webpack_require__(583)["default"] : __webpack_require__(585)["default"];

var App =
/** @class */
function (_super) {
  __extends(App, _super);

  function App() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  App.prototype.render = function () {
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_react_redux__["a" /* Provider */], {
      store: store
    }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* BrowserRouter */], {
      forceRefresh: !('pushState' in window.history)
    }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Switch */], null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], {
      path: "/",
      component: Home
    }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Redirect */], {
      from: "/*",
      to: "/"
    }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], {
      render: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, "404");
      }
    }))));
  };

  return App;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (App);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(13)))

/***/ }),

/***/ 319:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var promiseMiddleware = function promiseMiddleware() {
  return function (next) {
    return function (action) {
      var type = action.type,
          types = action.types,
          promise = action.promise,
          rest = __rest(action, ["type", "types", "promise"]); // console.log('action middleware ->', action);


      if (!promise) {
        return next(action);
      }

      if (type) {
        return promise.then(function (result) {
          if (result) {
            return next(__assign({
              type: type,
              result: result
            }, rest));
          } else {
            return next(__assign({
              type: type,
              error: 'no data returns'
            }, rest));
          }
        });
      }

      if (types) {
        var REQUEST = types[0],
            SUCCESS_1 = types[1],
            ERROR_1 = types[2];
        next(__assign({
          type: REQUEST
        }, rest));
        return promise.then(function (result) {
          if (!result) {
            return next(__assign({
              type: ERROR_1,
              error: 'no data returns'
            }, rest));
          }

          if (result.error) {
            return next(__assign({
              type: ERROR_1,
              error: result.error,
              result: result
            }, rest));
          } // console.log('promise middleware->', result)


          return next(__assign({
            type: SUCCESS_1,
            result: result
          }, rest));
        }, function (error) {
          next(__assign({
            type: ERROR_1,
            error: error
          }, rest));
        });
      }
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (promiseMiddleware);

/***/ }),

/***/ 320:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./article.ts": 117,
	"./comment.ts": 186,
	"./file.ts": 203,
	"./index.ts": 184,
	"./session.ts": 378
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 320;

/***/ }),

/***/ 321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = urlStringify;
function urlStringify(action) {
  var a = action ? Object.entries(action) : '';
  return a ? a.map(function (item) {
    return item.join('=');
  }).join('&') : '';
}

/***/ }),

/***/ 322:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 324:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 325:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 326:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 378:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createReducer__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_request__ = __webpack_require__(65);
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};



var namespace = 'session';
var initialState = {
  isSsoLogedIn: false,
  ssoUserInfo: {},
  userInfo: {},
  isLoggedIn: false
};
var reducer = {
  getSsoUserInfo: function getSsoUserInfo(state, action) {
    if (state === void 0) {
      state = initialState;
    }

    if (action.error || action.result.error) {
      return __assign(__assign({}, state), {
        isSsoLogedIn: false
      });
    }

    return __assign(__assign({}, state), {
      ssoUserInfo: action.result,
      isSsoLogedIn: true
    });
  },
  getUserInfo: function getUserInfo(state, action) {
    if (state === void 0) {
      state = initialState;
    }

    if (action.error || action.result.error) {
      // 如果用户没有登录, 而且用户的环境是在宝盒中, 应当登录, 就直接跳
      {
        var params = new URLSearchParams(window.location.search);
        console.log('params: ', params);
        var notAuthorized = params.get('authorized') === 'false';
        console.log('getUserInfo notAuthorized: ', notAuthorized);
        console.log('getUserInfo navigator.userAgent: ', navigator.userAgent);

        if (!notAuthorized && action.result && action.result.error === "need_login_first") {
          if (state.isSsoLogedIn || /ztobox|ztbox|baohe/.test(navigator.userAgent.toLowerCase())) {
            // 为防止不明原因导致可能存在的无限跳转, 需要额外记录上次刷新时间, 如果在5秒之内, 就不再刷新
            var lastLogin = localStorage.getItem("lastLogin");

            if (lastLogin !== null) {
              var lastTime = parseInt(lastLogin);
              var nowDate_1 = Date.now();

              if (nowDate_1 - lastTime < 1000 * 5) {
                // 不跳转
                return __assign(__assign({}, state), {
                  userInfo: {}
                });
              }
            }

            var nowDate = Date.now();
            localStorage.setItem("lastLogin", "" + nowDate);
            Object(__WEBPACK_IMPORTED_MODULE_1__utils_request__["b" /* jumpToOAuth2 */])();
          }
        }
      }
      return __assign(__assign({}, state), {
        userInfo: {}
      });
    }

    return __assign(__assign({}, state), {
      userInfo: action.result || {},
      isLoggedIn: true
    });
  }
};
/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_0__utils_createReducer__["a" /* createReducer */])(initialState, reducer, namespace));

/***/ }),

/***/ 379:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./index.ts": 204,
	"./session.ts": 380
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 379;

/***/ }),

/***/ 380:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["getUserInfo"] = getUserInfo;
/* harmony export (immutable) */ __webpack_exports__["getComments"] = getComments;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_request__ = __webpack_require__(65);
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};



var path = window.location.pathname.split("/");
var articleId = path[2];
var needLogin = !global.noAuth && path[1] === "article" && !!articleId;
function getUserInfo() {
  return __generator(this, function (_a) {
    switch (_a.label) {
      case 0:
        return [4
        /*yield*/
        , Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
          type: "session/getSsoUserInfo",
          promise: Object(__WEBPACK_IMPORTED_MODULE_1__utils_request__["a" /* getSsoUserInfo */])()
        })];

      case 1:
        _a.sent();

        return [4
        /*yield*/
        , Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* take */])("session/getSsoUserInfo")];

      case 2:
        _a.sent();

        return [4
        /*yield*/
        , Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
          type: "session/getUserInfo",
          promise: Object(__WEBPACK_IMPORTED_MODULE_1__utils_request__["c" /* request */])("/user/current")
        })];

      case 3:
        _a.sent();

        return [2
        /*return*/
        ];
    }
  });
}
function getComments() {
  var i;
  return __generator(this, function (_a) {
    switch (_a.label) {
      case 0:
        if (!needLogin) return [3
        /*break*/
        , 6];
        i = 0;
        _a.label = 1;

      case 1:
        if (!++i) return [3
        /*break*/
        , 6];
        if (!(i !== 1)) return [3
        /*break*/
        , 3];
        return [4
        /*yield*/
        , Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* take */])("comment/onCommentSuc")];

      case 2:
        _a.sent();

        _a.label = 3;

      case 3:
        return [4
        /*yield*/
        , Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* call */])(function (t) {
          return new Promise(function (resolve) {
            return setTimeout(resolve, t);
          });
        }, 500)];

      case 4:
        _a.sent();

        return [4
        /*yield*/
        , Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* put */])({
          type: "comment/getCommentList",
          promise: Object(__WEBPACK_IMPORTED_MODULE_1__utils_request__["c" /* request */])("/get_comments", {
            body: {
              id: articleId
            }
          })
        })];

      case 5:
        _a.sent();

        return [3
        /*break*/
        , 1];

      case 6:
        return [2
        /*return*/
        ];
    }
  });
} // export function *makePraise() {
//   if (needLogin){
//     yield take("comment/onPraise");
//     yield call(request, `/give_praise/${articleId}`, {method: "post"})
//   }
// }
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(13)))

/***/ }),

/***/ 583:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_article__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_css__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_css__);
var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};







var NoAuth =
/** @class */
function (_super) {
  __extends(NoAuth, _super);

  function NoAuth() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  NoAuth.prototype.componentDidMount = function () {
    // if (/ztobox|ztbox|baohe/.test(navigator.userAgent.toLowerCase())) {
    //     if (global.zt && global.zt.setTitle && global.PageTitle) {
    //         global.zt.setTitle({
    //             title: global.PageTitle,
    //             bgcolor: '#ffffff'
    //         });
    //     }
    //     if (global.zt && global.zt.updateShareContent) {
    //         const shareConfig = {
    //             title: global.PageTitle || '',
    //             desc: global.Title || '',
    //             thumbImageUrl: global.AppIcon || '',
    //             webpageUrl: global.location.href,
    //             timeline: global.Title || '',
    //         };
    //         global.zt.updateShareContent(shareConfig);
    //     }
    // }
    if (this.props.session.isLoggedIn) {
      this.loadShareConfig();
    }
  };

  NoAuth.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
    if (nextProps.session.isLoggedIn && !this.props.session.isLoggedIn) {
      this.loadShareConfig();
    }
  };

  NoAuth.prototype.loadShareConfig = function () {
    var location = this.props.location;
    var path = location.pathname.split("/");
    var articleId = path[2];

    if (/ztobox|ztbox|baohe/.test(navigator.userAgent.toLowerCase())) {
      this.props.getShareConfig({
        articleId: articleId
      });
    }
  };

  NoAuth.prototype.render = function () {
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
      className: "rootWrapper"
    }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
      className: "noAuthContent"
    }, "\u5BF9\u4E0D\u8D77\uFF0C\u60A8\u6682\u65E0\u67E5\u770B\u6743\u9650"));
  };

  NoAuth = __decorate([Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (_a) {
    var session = _a.session,
        comment = _a.comment,
        file = _a.file;
    return {
      session: session,
      comment: comment,
      file: file
    };
  }, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      getShareConfig: __WEBPACK_IMPORTED_MODULE_3__reducers_article__["getShareConfig"]
    }, dispatch);
  })], NoAuth);
  return NoAuth;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["default"] = (NoAuth);

/***/ }),

/***/ 584:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 585:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_less__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_mobile_es_button__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_mobile_es_button_style_css_js__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_mobile_es_modal__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_mobile_es_modal_style_css_js__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_mobile_es_textarea_item__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_mobile_es_textarea_item_style_css_js__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_mobile_es_toast__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_antd_mobile_es_toast_style_css_js__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__reducers_comment__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__reducers_article__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reducers_file__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_redux__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_request__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_querystring__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__WaterMark__ = __webpack_require__(611);
var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





















var mobileCheck = function mobileCheck() {
  var check = false;

  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);

  return check;
};

var isMobile = mobileCheck();

var App =
/** @class */
function (_super) {
  __extends(App, _super);

  function App(props) {
    var _this = _super.call(this, props) || this;

    var search = props.location.search;
    _this.state = {
      visible: false,
      praised: false,
      placeholder: "留言",
      replyId: undefined,
      content: "",
      isPreview: search ? __WEBPACK_IMPORTED_MODULE_17_querystring___default.a.parse(search.slice(1, search.length)).preview : false
    };
    _this.timeOut = 0;
    return _this;
  }

  App.prototype.componentDidMount = function () {
    var _this = this;

    if (this.state.isPreview) {
      if (document.querySelector(".notice")) {
        document.querySelector(".notice").setAttribute("style", "padding-top: 48px");
      }
    } // if (this.props.session.isLoggedIn) {
    //   this.loadFiles();
    // }


    window.onpopstate = function (event) {
      if (event.state === null && _this.state.visible) {
        _this.onClose();
      }
    };

    document.body.addEventListener("touchend", function (e) {
      if (e.target && e.target["id"] !== "input") {
        var input = document.getElementById("input");

        if (input) {
          input.blur();
        }
      }
    }); // if (/ztobox|ztbox|baohe/.test(navigator.userAgent.toLowerCase())) {
    //   if (global.zt && global.zt.setTitle && global.PageTitle) {
    //     global.zt.setTitle({
    //       title: global.PageTitle,
    //       bgcolor: '#ffffff'
    //     });
    //   }
    //   if (global.zt && global.zt.updateShareContent) {
    //     const shareConfig = {
    //       title: global.PageTitle || '',
    //       desc: global.Title || '',
    //       thumbImageUrl: global.AppIcon || '',
    //       webpageUrl: global.location.href,
    //       timeline: global.Title || '',
    //     };
    //     global.zt.updateShareContent(shareConfig);
    //   }
    // }

    if (this.props.session.isLoggedIn) {
      this.loadShareConfig();
    }
  };

  App.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
    if (nextProps.session.isLoggedIn && !this.props.session.isLoggedIn) {
      // this.loadFiles();
      this.loadShareConfig();
    }
  };

  App.prototype.loadFiles = function () {
    var location = this.props.location;
    var path = location.pathname.split("/");
    var articleId = path[2];
    this.props.getFileList({
      articleId: articleId
    });
  };

  App.prototype.loadShareConfig = function () {
    var location = this.props.location;
    var path = location.pathname.split("/");
    var articleId = path[2];

    if (/ztobox|ztbox|baohe/.test(navigator.userAgent.toLowerCase())) {
      this.props.getShareConfig({
        articleId: articleId
      });
    }
  };

  App.prototype.showTime = function (msgDate) {
    var nowDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()();
    var pastDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(new Date(msgDate));
    var isSameDay = nowDate.isSame(pastDate, 'day');
    var isSameYear = nowDate.isSame(pastDate, 'year');
    var isYesterday = nowDate.add('-1', 'day').isSame(pastDate, 'day');

    if (isSameDay) {
      return pastDate.format("HH:mm");
    } else if (isYesterday) {
      return "\u6628\u5929 " + pastDate.format("HH:mm");
    } else if (isSameYear) {
      return pastDate.format("MM-DD HH:mm");
    } else {
      return pastDate.format("YYYY-MM-DD HH:mm");
    } // let vDay = new Date(pastDate.getTime() + 24 * 60 * 60 * 1000);
    // let isYesterday =
    //   nowDate.getFullYear() === vDay.getFullYear() &&
    //   nowDate.getMonth() === vDay.getMonth() &&
    //   nowDate.getDate() === vDay.getDate();
    // let bDay = new Date(pastDate.getTime() + 24 * 60 * 60 * 1000 * 2);
    // let isDayBeforeYesterday =
    //   nowDate.getFullYear() === bDay.getFullYear() &&
    //   nowDate.getMonth() === bDay.getMonth() &&
    //   nowDate.getDate() === bDay.getDate();
    // if (moment().isSame(msgDate, "day")) {
    //   //同一天,显示时间
    //   result = moment(msgDate).format("HH:mm");
    // } else if (isYesterday) {
    //   result = "昨天" + moment(msgDate).format("HH:mm");
    // } else if (isDayBeforeYesterday) {
    //   result = "前天" + moment(msgDate).format("HH:mm");
    // } //显示日期
    // else {
    //   result = moment(msgDate).format("MM月DD");
    // }
    // return result;

  };

  App.prototype.onPraise = function (commentId) {
    if (!commentId && this.props.comment.readInfo.praised) return;

    if (commentId === 0) {
      this.setState({
        praised: true
      });
    }

    this.props.makePraise({
      commentId: commentId || 0
    });
  };

  App.prototype.onReply = function (item) {
    this.setState({
      placeholder: "\u56DE\u590D\uFF1A" + item.nick_name,
      replyId: item.id
    });
    this.showCommentControl();
  };

  App.prototype.showCommentControl = function (direct) {
    var need_audit = this.props.comment.readInfo.need_audit;
    window.history.pushState("forward", "", "#");
    this.setState({
      visible: true
    });

    if (direct && need_audit) {
      this.setState({
        placeholder: "留言将由管理员筛选后显示，对所有人可见。"
      });
    }
  };

  App.prototype.onComment = function () {
    if (!this.state.content) {
      __WEBPACK_IMPORTED_MODULE_10_antd_mobile_es_toast__["a" /* default */].info("要先填写评论才可以提交哦！", 2, undefined, false);
      return;
    }

    this.props.makeComment({
      reply_id: this.state.replyId,
      content: this.state.content
    });
    window.history.back();
  };

  App.prototype.onClose = function () {
    this.setState({
      visible: false,
      placeholder: "评论",
      replyId: undefined,
      content: ""
    });
  };

  App.prototype.onDelete = function (commentId) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_6_antd_mobile_es_modal__["a" /* default */].alert("删除", "确定要删除吗？", [{
      text: "取消",
      onPress: function onPress() {}
    }, {
      text: "确定",
      onPress: function onPress() {
        _this.props.deleteComment({
          comment_id: commentId
        });
      }
    }]);
  };

  App.prototype.onStick = function (id) {
    this.props.stickComment({
      comment_id: id
    });
  };

  App.prototype.openUserInfo = function (userId) {
    if (/ztobox|ztbox|baohe/.test(navigator.userAgent.toLowerCase())) {
      if (global.zt && global.zt.openUserInfo && typeof userId !== 'undefined') {
        global.zt.openUserInfo({
          userId: userId.toString()
        });
      }
    }
  };

  App.prototype.renderCommentItem = function (item) {
    var _this = this;

    var is_manager = this.props.comment.readInfo.is_manager;
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", __assign({
      key: item.id,
      className: __WEBPACK_IMPORTED_MODULE_3__index_less___default.a.comment_item + " clearfix"
    }, is_manager ? {
      onTouchEnd: function onTouchEnd() {
        clearTimeout(_this.timeOut);
      },
      onTouchMove: function onTouchMove() {
        clearTimeout(_this.timeOut);
        _this.timeOut = 0;
        return false;
      },
      onTouchStart: function onTouchStart() {
        _this.timeOut = setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_6_antd_mobile_es_modal__["a" /* default */].operation([{
            text: item.stick_at ? "取消置顶" : "置顶",
            onPress: function onPress() {
              _this.onStick(item.id);
            }
          }, {
            text: "删除",
            onPress: function onPress() {
              _this.onDelete(item.id);
            }
          }]);
        }, 500);
        return false;
      },
      onClick: isMobile ? undefined : function () {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_es_modal__["a" /* default */].operation([{
          text: item.stick_at ? "取消置顶" : "置顶",
          onPress: function onPress() {
            _this.onStick(item.id);
          }
        }, {
          text: "删除",
          onPress: function onPress() {
            _this.onDelete(item.id);
          }
        }]);
      }
    } : {}), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
      className: __WEBPACK_IMPORTED_MODULE_3__index_less___default.a.comment_avatar,
      onClick: function onClick() {
        _this.openUserInfo(item.user_id);
      }
    }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", {
      src: item.avatar
    })), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
      className: __WEBPACK_IMPORTED_MODULE_3__index_less___default.a.comment_content
    }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
      className: __WEBPACK_IMPORTED_MODULE_3__index_less___default.a.comment_nickname
    }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", {
      onClick: function onClick() {
        _this.openUserInfo(item.user_id);
      }
    }, item.nick_name), item.stick_at && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", {
      className: __WEBPACK_IMPORTED_MODULE_3__index_less___default.a.stick
    }, "\u7F6E\u9876"), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", {
      className: __WEBPACK_IMPORTED_MODULE_3__index_less___default.a.praise_comment,
      onClick: item.praised ? function () {} : this.onPraise.bind(this, item.id)
    }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", {
      src: item.praised ? __webpack_require__(241) : __webpack_require__(242)
    }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, " ", item.praise_num === 0 ? "" : item.praise_num)), is_manager && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", {
      className: __WEBPACK_IMPORTED_MODULE_3__index_less___default.a.comment_entry,
      onClick: this.onReply.bind(this, item)
    }))), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", {
      className: __WEBPACK_IMPORTED_MODULE_3__index_less___default.a.date_stamp
    }, this.showTime(item.created_at))), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, item.content), item.reply ? item.reply.map(function (i, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
        key: index,
        className: __WEBPACK_IMPORTED_MODULE_3__index_less___default.a.reply
      }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", {
        onClick: function onClick() {
          _this.openUserInfo(i.user_id);
        }
      }, i.nick_name, " \uFF1A"), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, i.content), is_manager && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", {
        className: __WEBPACK_IMPORTED_MODULE_3__index_less___default.a.reply_delete,
        onClick: _this.onDelete.bind(_this, i.id)
      }, "[\u5220\u9664]"));
    }) : null));
  }; // renderFiles() {
  //   const { file: { files, hasFile } } = this.props;
  //   if (!hasFile) return null;
  //   return <div className="files">
  //     <p style={{ margin: '5px 0' }}>附件列表</p>
  //     <div>
  //       {files.map(file => <div className={styles.fileInfo} key={file.id}>
  //         <span>
  //           <Icon type="file" />
  //         </span>
  //         <div className={styles.fileName}>{file.name}</div>
  //       </div>)}
  //     </div>
  //   </div>;
  // }


  App.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        userInfo = _a.session.userInfo,
        _b = _a.comment,
        commentList = _b.commentList,
        readInfo = _b.readInfo;

    if (!userInfo.user_id) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
        key: "container",
        className: __WEBPACK_IMPORTED_MODULE_3__index_less___default.a.container
      }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
        className: __WEBPACK_IMPORTED_MODULE_3__index_less___default.a.header
      }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", {
        onClick: function onClick() {
          Object(__WEBPACK_IMPORTED_MODULE_16__utils_request__["b" /* jumpToOAuth2 */])();
        }
      }, "\u767B\u5F55")));
    }

    var previewHint = this.state.isPreview ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
      className: __WEBPACK_IMPORTED_MODULE_3__index_less___default.a.preview_hint,
      key: "preview-bar"
    }, "\u9884\u89C8\u6548\u679C\uFF0C\u4EC5\u81EA\u5DF1\u53EF\u89C1") : null;
    var waterMark = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18__WaterMark__["a" /* default */], null);
    var controller = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
      key: "controller",
      className: __WEBPACK_IMPORTED_MODULE_3__index_less___default.a.controller
    }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", {
      className: __WEBPACK_IMPORTED_MODULE_3__index_less___default.a.read_count
    }, "\u9605\u8BFB ", readInfo.read_count), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", {
      className: __WEBPACK_IMPORTED_MODULE_3__index_less___default.a.praise_count,
      onClick: this.onPraise.bind(this, 0)
    }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", {
      src: readInfo.praised || this.state.praised ? __webpack_require__(241) : __webpack_require__(242)
    }), (readInfo.praise_num > 0 || this.state.praised) && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, " ", this.state.praised ? readInfo.praise_num + 1 : readInfo.praise_num)));
    var comments = readInfo.allow_comment ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
      key: "container",
      className: __WEBPACK_IMPORTED_MODULE_3__index_less___default.a.container
    }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
      className: __WEBPACK_IMPORTED_MODULE_3__index_less___default.a.header
    }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", {
      onClick: this.showCommentControl.bind(this, true)
    }, "\u5199\u7559\u8A00")), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, commentList.map(function (item) {
      return _this.renderCommentItem(item);
    })), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
      className: __WEBPACK_IMPORTED_MODULE_3__index_less___default.a.footer
    }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_antd_mobile_es_modal__["a" /* default */], {
      visible: this.state.visible,
      maskClosable: false,
      transparent: true,
      popup: true,
      animationType: "slide-up",
      className: __WEBPACK_IMPORTED_MODULE_3__index_less___default.a.comment_controller
    }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
      className: __WEBPACK_IMPORTED_MODULE_3__index_less___default.a.comment_box,
      ref: function ref(ins) {
        if (ins) {
          document.getElementsByClassName("am-modal-wrap-popup")[0].addEventListener("touchmove", function (e) {
            if (e.target && e.target["id"] !== "input") {
              e.preventDefault();
            }
          }, false);
        }
      }
    }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", null, "\u5199\u7559\u8A00"), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_antd_mobile_es_textarea_item__["a" /* default */], {
      id: "input",
      className: __WEBPACK_IMPORTED_MODULE_3__index_less___default.a.textArea,
      // autoFocus
      rows: 5,
      count: 150,
      value: this.state.content,
      onChange: function onChange(value) {
        _this.setState({
          content: value ? value.replace(/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g, "") : ""
        });
      },
      placeholder: this.state.placeholder
    }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
      className: __WEBPACK_IMPORTED_MODULE_3__index_less___default.a.comment_control
    }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_mobile_es_button__["a" /* default */], {
      className: __WEBPACK_IMPORTED_MODULE_3__index_less___default.a.comment_button,
      onClick: this.onComment.bind(this),
      type: "primary"
    }, "\u7559 \u8A00"), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_antd_mobile_es_button__["a" /* default */], {
      className: __WEBPACK_IMPORTED_MODULE_3__index_less___default.a.comment_button,
      onClick: function onClick() {
        window.history.back();
      },
      type: "warning"
    }, "\u53D6\u6D88"))))) : null;
    return [previewHint, waterMark, controller, comments];
  };

  App = __decorate([Object(__WEBPACK_IMPORTED_MODULE_15_react_redux__["b" /* connect */])(function (_a) {
    var session = _a.session,
        comment = _a.comment,
        file = _a.file;
    return {
      session: session,
      comment: comment,
      file: file
    };
  }, function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      makePraise: __WEBPACK_IMPORTED_MODULE_12__reducers_comment__["makePraise"],
      makeComment: __WEBPACK_IMPORTED_MODULE_12__reducers_comment__["makeComment"],
      deleteComment: __WEBPACK_IMPORTED_MODULE_12__reducers_comment__["deleteComment"],
      stickComment: __WEBPACK_IMPORTED_MODULE_12__reducers_comment__["stickComment"],
      getFileList: __WEBPACK_IMPORTED_MODULE_14__reducers_file__["getFileList"],
      getShareConfig: __WEBPACK_IMPORTED_MODULE_13__reducers_article__["getShareConfig"]
    }, dispatch);
  }), __metadata("design:paramtypes", [Object])], App);
  return App;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["default"] = (App);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(13)))

/***/ }),

/***/ 588:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1o5OAZ_jueFuSa13Ebqk6s","fileInfo":"_2Z1BcePj8gYFz7RhdDeA_r","fileName":"_2n53bktyyQJ-LFc-G_Ta8F","preview_hint":"_3CyR_CwI8gnm2-Kjkx_Mt8","comment_controller":"_2BSrCWrWOJTuBlHxfsDud","comment_box":"_lE0QAAUlx7MZWEdtPzit","textArea":"_2UJNQ04fBOTMY5kqnxSjdG","comment_control":"_2Vt9yfbOqy3GICrWFRnC8Z","comment_button":"_2v8hLF4avdgHg8XIo6HPt2","controller":"_1tP0Jx0mVh_EEios65Yqpm","read_count":"_2Y4zoU7dL-Y_qPK27xmH50","praise_count":"_1dRkU4MhGRfuoy6bfp5LCO","header":"_1RsOTdzb5YZRm5vHvO_oXz","footer":"_1JYdczQ3a63dXjQzKowoaA","comment_item":"_2vQ4vS8qgDZMwwrCk9r2ED","comment_avatar":"MBEUfPE9ux0ZxA23M-t9K","comment_content":"_2cKOPCW2ajCHBaaVra4X2X","comment_nickname":"_17FRPeK8Vs5JTsJ5r9arJ9","stick":"_1S1L6vW4QGr_DVSRrEymXE","comment_delete":"_1mXyBRTAok1gb2iAVaH8Zf","comment_entry":"_1qaK-10A_Smy-YVWJ0Uizw","praise_comment":"_3rVcWLes-icqzRv8ntlbn4","date_stamp":"_1BU2aRB7PdbfWVy-qiDjLk","reply":"_4rDk6cBCj1TSCEmqbLe-K","reply_delete":"_200HSo8lYUjDnnBoJrISWo"};

/***/ }),

/***/ 592:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 601:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 606:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 607:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 611:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(86);
var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();




var WaterMark =
/** @class */
function (_super) {
  __extends(WaterMark, _super);

  function WaterMark() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {};

    _this.renderContent = function () {
      var _a = _this.state,
          row = _a.row,
          col = _a.col;
      var _b = _this.props,
          name = _b.name,
          mobile = _b.mobile;
      var text = '';

      if (name) {
        text += name;
      }

      if (mobile) {
        text += ' ' + mobile.slice(-4);
      }

      var content = [];
      var width = (100 / col).toFixed(2) + '%';

      for (var i = 0; i < row; i++) {
        var arr = [];

        for (var j = 0; j < col; j++) {
          var style = {
            width: width
          };
          var isEvenRow = i % 2 === 0;
          var isEvenCol = j % 2 === 0;
          var childText = void 0;

          if (isEvenRow) {
            childText = isEvenCol ? text : 'ZTO';
            style.textAlign = isEvenCol ? 'left' : 'center';
          } else {
            childText = isEvenCol ? 'ZTO' : text;
            style.textAlign = isEvenCol ? 'center' : 'left';
          }

          arr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
            style: style,
            key: i + '_' + j
          }, childText));
        }

        content.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: "clearfix"
        }, arr));
      }

      return content;
    };

    return _this;
  }

  WaterMark.prototype.componentDidMount = function () {
    this.initTimer();
  };

  WaterMark.prototype.componentWillUnmount = function () {
    if (this.watcher) {
      window.cancelAnimationFrame(this.watcher);
    }
  };

  WaterMark.prototype.initTimer = function () {
    var _this = this;

    if (this.container) {
      var lastScrollHeight_1;
      var lastScrollWidth_1;

      var watch_1 = function watch_1() {
        if (_this.container) {
          if (lastScrollHeight_1 !== _this.container.scrollHeight || lastScrollWidth_1 !== _this.container.scrollWidth) {
            var row = Math.floor(_this.container.scrollHeight / 60);
            var col = Math.floor(_this.container.offsetWidth / 100);

            _this.setState({
              col: col,
              row: row
            });
          }

          lastScrollHeight_1 = _this.container.scrollHeight;
          lastScrollWidth_1 = _this.container.scrollWidth;
        }

        _this.watcher = requestAnimationFrame(watch_1);
      };

      this.watcher = window.requestAnimationFrame(watch_1);
    }
  };

  WaterMark.prototype.renderMarks = function () {
    var _a = this.props,
        name = _a.name,
        mobile = _a.mobile;
    var _b = this.state,
        row = _b.row,
        col = _b.col;
    var text = '';

    if (name) {
      text += name;
    }

    if (mobile) {
      text += ' ' + mobile.slice(-4);
    }

    if (text && row && col) {
      return this.renderContent();
    }

    return null;
  };

  WaterMark.prototype.render = function () {
    var _this = this;

    if (!this.props.isLoggedIn) return null;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "water_mark_container",
      ref: function ref(el) {
        _this.container = el;
      }
    }, this.renderMarks());
  };

  return WaterMark;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

function mapStateToProps(_a) {
  var _b = _a.session,
      userInfo = _b.ssoUserInfo,
      isLoggedIn = _b.isLoggedIn;
  return {
    name: userInfo.fullname,
    mobile: userInfo.mobile_phone,
    isLoggedIn: isLoggedIn
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(WaterMark));

/***/ }),

/***/ 612:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 613:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_lazyload__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lib_lazyload__);

var $imgs = $(".content").find("img");
var $set;
var images = [];
$imgs.each(function (index, elem) {
  var $this = $(elem);
  var src = $this.attr("src");
  var $newImg = $this.clone().attr("data-src", src).attr("src", "/article/loading.gif");
  images.push(src);

  if ($set) {
    $set = $set.add($newImg);
  } else {
    $set = $newImg;
  }

  $this.replaceWith($newImg);
});
$(".content").removeClass("hideImage");

if ($set && $set.length > 0) {
  var flag = false;
  var img = new Image();
  img.src = "/article/loading.gif";

  if (img.complete) {
    flag = true;
    $set.lazyload();
  }

  img.onload = function () {
    if (flag === false) {
      $set.lazyload();
    }
  };

  if (/ztobox|ztbox|baohe/.test(navigator.userAgent.toLowerCase()) && global.zt) {
    console.log("==============================");
    console.log("图片事件点击事件绑定");
    $(".content").on("click", "img", function () {
      var $img = $(this);

      if ($img.parentsUntil(".content").filter("a[href]").length > 0) {
        return;
      }

      console.log("==============================");
      console.log("调用宝盒sdk图片查看方法");
      console.log("参数", images, $set.index($img));
      zt.extend({
        name: "ztoBoxOpenImage",
        params: {
          images: images,
          currentIndex: $set.index($img)
        },
        success: function success(res) {
          console.log(res);
        }
      });
    });
  }
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(13)))

/***/ }),

/***/ 614:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*!
 * Lazy Load - JavaScript plugin for lazy loading images
 *
 * Copyright (c) 2007-2019 Mika Tuupola
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * Project home:
 *   https://appelsiini.net/projects/lazyload
 *
 * Version: 2.0.0-rc.2
 *
 */
(function (root, factory) {
  if (true) {
    module.exports = factory(root);
  } else if (typeof define === "function" && define.amd) {
    define([], factory);
  } else {
    root.LazyLoad = factory(root);
  }
})(typeof global !== "undefined" ? global : this.window || this.global, function (root) {
  "use strict";

  if (true) {
    root = window;
  }

  var defaults = {
    src: "data-src",
    srcset: "data-srcset",
    selector: ".lazyload",
    root: null,
    rootMargin: "0px",
    threshold: 0
  };
  /**
  * Merge two or more objects. Returns a new object.
  * @private
  * @param {Boolean}  deep     If true, do a deep (or recursive) merge [optional]
  * @param {Object}   objects  The objects to merge together
  * @returns {Object}          Merged values of defaults and options
  */

  var extend = function extend() {
    var extended = {};
    var deep = false;
    var i = 0;
    var length = arguments.length;
    /* Check if a deep merge */

    if (Object.prototype.toString.call(arguments[0]) === "[object Boolean]") {
      deep = arguments[0];
      i++;
    }
    /* Merge the object into the extended object */


    var merge = function merge(obj) {
      for (var prop in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, prop)) {
          /* If deep merge and property is an object, merge properties */
          if (deep && Object.prototype.toString.call(obj[prop]) === "[object Object]") {
            extended[prop] = extend(true, extended[prop], obj[prop]);
          } else {
            extended[prop] = obj[prop];
          }
        }
      }
    };
    /* Loop through each object and conduct a merge */


    for (; i < length; i++) {
      var obj = arguments[i];
      merge(obj);
    }

    return extended;
  };

  function LazyLoad(images, options) {
    this.settings = extend(defaults, options || {});
    this.images = images || document.querySelectorAll(this.settings.selector);
    this.observer = null;
    this.init();
  }

  LazyLoad.prototype = {
    init: function init() {
      /* Without observers load everything and bail out early. */
      if (!root.IntersectionObserver) {
        this.loadImages();
        return;
      }

      var self = this;
      var observerConfig = {
        root: this.settings.root,
        rootMargin: this.settings.rootMargin,
        threshold: [this.settings.threshold]
      };
      this.observer = new IntersectionObserver(function (entries) {
        Array.prototype.forEach.call(entries, function (entry) {
          if (entry.isIntersecting) {
            self.observer.unobserve(entry.target);
            var src = entry.target.getAttribute(self.settings.src);
            var srcset = entry.target.getAttribute(self.settings.srcset);

            if ("img" === entry.target.tagName.toLowerCase()) {
              if (src) {
                entry.target.src = src;
              }

              if (srcset) {
                entry.target.srcset = srcset;
              }
            } else {
              entry.target.style.backgroundImage = "url(" + src + ")";
            }
          }
        });
      }, observerConfig);
      Array.prototype.forEach.call(this.images, function (image) {
        self.observer.observe(image);
      });
    },
    loadAndDestroy: function loadAndDestroy() {
      if (!this.settings) {
        return;
      }

      this.loadImages();
      this.destroy();
    },
    loadImages: function loadImages() {
      if (!this.settings) {
        return;
      }

      var self = this;
      Array.prototype.forEach.call(this.images, function (image) {
        var src = image.getAttribute(self.settings.src);
        var srcset = image.getAttribute(self.settings.srcset);

        if ("img" === image.tagName.toLowerCase()) {
          if (src) {
            image.src = src;
          }

          if (srcset) {
            image.srcset = srcset;
          }
        } else {
          image.style.backgroundImage = "url('" + src + "')";
        }
      });
    },
    destroy: function destroy() {
      if (!this.settings) {
        return;
      }

      this.observer.disconnect();
      this.settings = null;
    }
  };

  root.lazyload = function (images, options) {
    return new LazyLoad(images, options);
  };

  if (root.jQuery) {
    var $_1 = root.jQuery;

    $_1.fn.lazyload = function (options) {
      options = options || {};
      options.attribute = options.attribute || "data-src";
      new LazyLoad($_1.makeArray(this), options);
      return this;
    };
  }

  return LazyLoad;
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ }),

/***/ 65:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return request; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return jumpToOAuth2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSsoUserInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__urlStringify__ = __webpack_require__(321);
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};


var host = window.location.origin + "/api";
var appId = "zt5KHiUpFQVtWyzU7QoMYjbQ";
global.host = host;
var path = window.location.pathname.split("/");
var articleId = path[2];
var request = function request(url, options, count) {
  if (count === void 0) {
    count = 0;
  }

  return __awaiter(void 0, void 0, void 0, function () {
    var _options, headers, body, form, rest, response, status, result, e_1;

    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _options = {
            headers: {
              "Content-Type": "application/json; charset=utf-8",
              "X-Article-Id": articleId
            }
          };

          if (options) {
            headers = options.headers, body = options.body, form = options.form, rest = __rest(options, ["headers", "body", "form"]);

            if (headers) {
              Object.assign(_options.headers, headers);
            }

            if (form) {
              Object.assign(_options.headers, {
                'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
              });
              Object.assign(_options, {
                body: Object(__WEBPACK_IMPORTED_MODULE_0__urlStringify__["a" /* default */])(form)
              }, rest);
            } else {
              if (rest.method === 'post' || rest.method === 'POST') {
                Object.assign(_options, {
                  body: JSON.stringify(body)
                }, rest);
              } else {
                url = count === 0 ? url + '?' + Object(__WEBPACK_IMPORTED_MODULE_0__urlStringify__["a" /* default */])(body) : url;
                Object.assign(_options, rest);
              }
            }
          }

          if (url.indexOf('http') === -1) {
            url = host + url;
          }

          console.log("request ->", url, _options);
          _a.label = 1;

        case 1:
          _a.trys.push([1, 6,, 7]);

          return [4
          /*yield*/
          , fetch(url, __assign({
            method: 'get',
            cache: 'default',
            credentials: 'include'
          }, _options))];

        case 2:
          response = _a.sent();
          status = response.status;
          return [4
          /*yield*/
          , response.json()];

        case 3:
          result = _a.sent();

          if (status === 401) {}

          if (!(status === 403 && count < 3)) return [3
          /*break*/
          , 5];
          return [4
          /*yield*/
          , request(url, options, count + 1)];

        case 4:
          _a.sent();

          return [2
          /*return*/
          ];

        case 5:
          return [2
          /*return*/
          , result];

        case 6:
          e_1 = _a.sent();
          console.error("request error->", e_1);
          return [3
          /*break*/
          , 7];

        case 7:
          return [2
          /*return*/
          ];
      }
    });
  });
};

var randomString = function randomString(length) {
  var text = "";
  var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (var i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return text;
};

var jumpToOAuth2 = function jumpToOAuth2() {
  var ssoEndPoint = 'https://sso.zto.com';

  if (window.location.origin !== 'https://jxadmin.zt-express.com') {
    ssoEndPoint = 'http://sso.test.ztosys.com';
  }

  location.href = ssoEndPoint + "/oauth2/authorize?appid=" + appId + "&redirect_uri=" + ("" + encodeURIComponent(host + "/oauth2/callback?redirect_uri=" + encodeURIComponent(window.location.href))) + ("&response_type=code&scope=userinfo,user_id,usercontact&state=" + randomString(16));
};
var getSsoUserInfo = function getSsoUserInfo() {
  var ssoEndPoint = 'https://sso.zto.com';

  if (window.location.origin !== 'https://jxadmin.zt-express.com') {
    ssoEndPoint = 'http://sso.test.ztosys.com';
  }

  return request(ssoEndPoint + "/users/current/profile", {
    credentials: 'include'
  });
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(13)))

/***/ }),

/***/ 87:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createReducer; });
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var createReducer = function createReducer(initialState, reducers, namespace) {
  return function (state, action) {
    if (state === void 0) {
      state = initialState;
    }

    var type = '';
    var str = action.type.split('/');

    if (str.length > 1) {
      if (str[0] !== namespace) {
        return state;
      }

      type = str[1];
    } else {
      type = action.type;
    }

    var reducerFunc = reducers[type];

    if (!reducerFunc) {
      // ignore, not to update
      return state;
    } // update the reducer tree


    return __assign(__assign({}, state), reducerFunc(state, action));
  };
};

/***/ })

},[243]);


// WEBPACK FOOTER //
// static/js/main.d93a394e.js